import { HStack, Container, Button, Image, Text, Show, Box, Spacer } from '@chakra-ui/react';
import React from 'react';
import { TFunction } from 'i18next';
import logo from '@/assets/images/logo-blue.svg';
import MobileNavigation from './MobileNavigation';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import DesktopNavigation from './DesktopNavigation';

export interface NavigationBarProps {
  t: TFunction;
  scrollToShowcases: () => void;
  scrollToFeatures: () => void;
  scrollToPricing: () => void;
}

const NavigationBar: React.VFC<NavigationBarProps> = ({ ...rest }) => {
  return (
    <HStack
      as="header"
      backdropFilter="saturate(180%) blur(5px)"
      bg="rgba(255,255,255,0.8)"
      h={['70px', '115px']}
      position="sticky"
      top="0px"
      w="100%"
      zIndex="999">
      <Container maxW="container.xl">
        <HStack align="center" as="nav" h="100%" justify="space-between">
          <Image h={[6, 8, 10]} src={logo} />
          <Show above="md">
            <HStack spacing="8">
              <DesktopNavigation {...rest} />
            </HStack>
          </Show>
          <Show below="md">
            <HStack>
              <LanguageSwitcher buttonTextColor="black" optionTextColor="black" />
              <MobileNavigation {...rest} />
            </HStack>
          </Show>
        </HStack>
      </Container>
    </HStack>
  );
};

export default NavigationBar;
